import { render, staticRenderFns } from "./MoreActionsModal.vue?vue&type=template&id=588173fd&scoped=true&"
import script from "./MoreActionsModal.vue?vue&type=script&lang=js&"
export * from "./MoreActionsModal.vue?vue&type=script&lang=js&"
import style0 from "./MoreActionsModal.vue?vue&type=style&index=0&id=588173fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588173fd",
  null
  
)

export default component.exports